export default [
    {
        path: "/:catalog/product",
        name: "product",
        component: () => import("./components/main-view.vue"),
        meta: {
            title: "OneBuy",
        },
    },
    {
        path: "/:catalog/product/:productId",
        props: true,
        name: "product-detail",
        component: () => import("./components/product-detail.vue"),
        meta: {
            title: "OneBuy",
        }
    },
];
